module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "FLDAS_Dataset_Cover.d973ed7c.jpg";